import { render, staticRenderFns } from "./LKPassportTemplateTable.vue?vue&type=template&id=529b020f&"
import script from "./LKPassportTemplateTable.vue?vue&type=script&lang=js&"
export * from "./LKPassportTemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./LKPassportTemplateTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VLayout,VSpacer,VTab,VTabs,VTabsSlider,VTooltip})
